import axios, { AxiosError, AxiosInstance } from 'axios'
import type { APIError } from '@/types/api'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api/v1'

// Создаем axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  // Не устанавливаем дефолтный Content-Type - axios установит его автоматически
  // для JSON это будет application/json, для FormData - multipart/form-data
  timeout: 120000, // 2 минуты для операций с LLM (импорт спортсменов)
})

// Request interceptor - добавляем Telegram Init Data для аутентификации
apiClient.interceptors.request.use(
  (config) => {
    // Получаем initData из Telegram WebApp
    const initData = window.Telegram?.WebApp?.initData
    if (initData) {
      config.headers['X-Telegram-Init-Data'] = initData
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor - обработка ошибок
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<APIError>) => {
    if (error.response) {
      // Сервер ответил с кодом ошибки
      const data = error.response.data as any
      const apiError: APIError = {
        // Простой формат: {"error": "...", "details": "..."}
        error: data?.error || data?.message || 'Unknown error',
        details: data?.details,
        // AppError формат: {"code": "...", "message": "...", "context": {...}}
        code: data?.code,
        message: data?.message,
        context: data?.context,
        status: error.response.status,
      }
      return Promise.reject(apiError)
    } else if (error.request) {
      // Запрос был отправлен, но ответа не получено
      return Promise.reject({
        error: 'Network error',
        details: 'Could not connect to server',
      })
    } else {
      // Ошибка при настройке запроса
      return Promise.reject({
        error: 'Request error',
        details: error.message,
      })
    }
  }
)

export default apiClient
